import browserOnly from 'src/lib/browserOnly';
import IStoreState from 'src/types/IStoreState';

const getPathname = (state: IStoreState): string =>
  browserOnly(() => location.pathname, state.flow.pathname);

export default getPathname;
